import MessageViewer from "./common/message.js";

export default {
    tags        : [ "Message" ],
    name        : "message_delete",
    viewer      : MessageViewer,

    definition: (i18n, log) => {
        return (!log.target || log.executor === log.target)
            ? i18n("logs_definition.message_delete")
            : i18n("logs_definition.message_delete_other");
    },

    filter: {
        icon: "chat",
        name: (i18n) => "Suppression de message",
    },
}
